import { render, staticRenderFns } from "./LiveVideoSwArea.vue?vue&type=template&id=e8c67e9e&"
import script from "./LiveVideoSwArea.vue?vue&type=script&lang=js&"
export * from "./LiveVideoSwArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports